import React, { Fragment } from 'react'
import { useTheme } from '@opallabs/hooks'
import { Token, kuiperClassNames } from '@opallabs/kuiper'
import * as styles from './styles'

export type Label = { labelSet: string; labels: Array<string> }

type LabelDetailsProps = {
  labels: Array<Label>
}

export const LabelDetails: React.FC<LabelDetailsProps> = ({ labels }) => {
  const theme = useTheme()

  return (
    <div
      css={[styles.labelSet(theme), styles.groupText]}
      className={kuiperClassNames('label-set')}
    >
      Labels
      {labels.map((labelSet) => (
        <Fragment key={labelSet.labelSet}>
          <div
            css={styles.optionTitle}
            className={kuiperClassNames('label-set-title')}
          >
            {labelSet.labelSet}
          </div>
          {labelSet.labels.map((label) => (
            <Token
              key={label}
              removable={false}
              selectable={false}
              title={label}
              icon="label"
            />
          ))}
        </Fragment>
      ))}
    </div>
  )
}
